import { render, staticRenderFns } from "./InsertPriceListProposal.vue?vue&type=template&id=32faf27e"
import script from "./InsertPriceListProposal.vue?vue&type=script&lang=js"
export * from "./InsertPriceListProposal.vue?vue&type=script&lang=js"
import style0 from "./InsertPriceListProposal.vue?vue&type=style&index=0&id=32faf27e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports